"use client";

import { useEffect, useState } from "react";
import { DiagramType } from "../types/types";
import { BookIcon } from "./icons/BookIcon";
import { useTranslation } from "react-i18next";

type ItemType = {
  top?: DiagramType;
  bottom?: DiagramType;
};

const SELECTED_COLOR = "#B0B0B0";

const CardItem = ({
  brand,
  data,
  selectedDiagram,
  onSelected,
}: {
  brand: string;
  data: ItemType;
  selectedDiagram?: DiagramType;
  onSelected: (diagramId: DiagramType) => void;
}) => {
  const { t } = useTranslation();

  return (
    <div className="h-full">
      {data.top && (
        <div
          className="flex-none cursor-pointer me-1 p-1 h-1/2 rounded-lg"
          style={{ width: 119, backgroundColor: selectedDiagram?.id === data.top.id ? SELECTED_COLOR : "transparent" }}
          onClick={() => onSelected(data.top!)}
        >
          <img alt="" src={`https://partsfinder.clpstudio.ro/diagrams/${brand}/${data.top.category}.gif`} width={119} height={91} className="rounded-lg" />
          <p className="w-full text-wrap break-words mt-1 lg:text-xs text-xxs text-black">{data.top.title}</p>
        </div>
      )}

      {data.bottom && (
        <div
          className="flex-none cursor-pointer me-1 p-1 mt-1 h-1/2 rounded-lg"
          style={{ width: 119, backgroundColor: selectedDiagram?.id === data.bottom.id ? SELECTED_COLOR : "transparent" }}
          onClick={() => onSelected(data.bottom!)}
        >
          <img alt="" src={`https://partsfinder.clpstudio.ro/diagrams/${brand}/${data.bottom.category}.gif`} width={119} height={91} className="rounded-lg" />
          <p className="w-full text-wrap break-words lg:text-xs text-xxs text-black">{data.bottom.title}</p>
        </div>
      )}
    </div>
  );
};

export const DiagramSelector = ({
  brand,
  diagrams,
  selectedDiagram,
  ownerManualLink,
  onSelected,
}: {
  brand: string;
  diagrams: DiagramType[];
  selectedDiagram?: DiagramType;
  ownerManualLink?: string;
  onSelected: (diagramId: DiagramType) => void;
}) => {
  const [data, setData] = useState<ItemType[]>([]);
  const { t } = useTranslation();

  useEffect(() => {
    const topRow = diagrams.filter((t) => t.engine !== true);
    const bottomRow = diagrams.filter((t) => t.engine === true);
    const maxLength = topRow.length > bottomRow.length ? topRow.length : bottomRow.length;

    let res: ItemType[] = [];
    for (let i = 0; i < maxLength; i++) {
      const top = topRow[i];
      const bottom = bottomRow[i];

      res = [...res, { top, bottom }];
    }

    setData(res);
  }, [diagrams]);

  return (
    <div className="w-full flex flex-col mt-5">
      <div className="w-full flex justify-between items-center">
        <h1 className="text-xl text-black">{t("diagram_selector_title")}</h1>

        {ownerManualLink && (
          <div className="flex items-center text-blue-400 underline cursor-pointer" onClick={() => window.open(ownerManualLink, "_blank")}>
            <span>{t("diagram_selector_owner_manual")}</span>
            <BookIcon />
          </div>
        )}
      </div>

      <div className="w-full flex mt-1 overflow-x-scroll overflow-y-hidden pb-1" style={{ height: 300 }}>
        {data.map((t, index) => {
          return <CardItem key={index} brand={brand} data={t} onSelected={onSelected} selectedDiagram={selectedDiagram} />;
        })}
      </div>
    </div>
  );
};
